import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {UrlService} from '@shared/services/url.service';
import {Observable} from 'rxjs';
import {API_ENTITY_ACCOUNT_TRANSACTIONS, API_ENTITY_ACCOUNTS} from '../../../config/urls';
import {EntityAccountListDto} from '@dto/holdings/entity-account-list.dto';
import {EntityAccountTransactionListDto} from '@dto/holdings/entity-account-transaction-list.dto';

@Injectable({
  providedIn: 'root'
})
export class EntityAccountService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getEntityAccounts(entityCode: string): Observable<EntityAccountListDto> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_ACCOUNTS, entityCode);
    return this.http.get<EntityAccountListDto>(endpointUrl);
  }

  public getEntityAccountTransactions(entityCode: string, entityAccountId: string): Observable<EntityAccountTransactionListDto> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_ACCOUNT_TRANSACTIONS, entityCode, entityAccountId);
    return this.http.get<EntityAccountTransactionListDto>(endpointUrl);
  }
}
